<template>
    <share-link-setup
        v-if="session.share_link.id"
        v-on:submit="submitSetupData($event)"
        :link="session.share_link"
        :title="session.case.public_title"
        :loading="isLoading"
        :errors="errors"
    ></share-link-setup>
</template>

<script>
import http from "@/axios.js"
import ShareLinkSetup from "@/components/ShareLinkSetup"

export default {
    name: "CaseSessionSetup",
    components: {
        ShareLinkSetup,
    },
    data() {
        return {
            session: {
                share_link: {
                    require_passcode: false,
                    identification_method: "none",
                    id: null
                },
                case: {
                    public_title: "",
                    cover_image: null,
                },
            },
            isLoading: false,
            errors: [],
        }
    },
    computed: {
        sessionID() {
            return this.$route.params.sessionID
        },
        shareLinkID() {
            return this.$route.params.shareLinkID
        },
    },
    methods: {
        fetchData() {
            let vm = this
            http.get(`/api/sessions/${this.sessionID}/setup/`).then((response) => {
                vm.session = response.data
                vm.$store.commit("setSession", response.data)
            })
        },
        submitSetupData(setupData) {
            this.isLoading = true
            let vm = this
            http.post(`/api/sessions/${this.sessionID}/setup/`, setupData)
                .then((response) => {
                    if (response.data.is_valid) {
                        // Proceed to the session view.
                        vm.$router.push({
                            name: "ShareLinkCaseSession",
                            params: {
                                shareLinkID: vm.shareLinkID,
                                sessionID: vm.sessionID,
                            },
                        })
                    } else {
                        vm.errors = response.data.errors
                    }
                })
                .finally(() => (vm.isLoading = false))
        },
    },
    mounted() {
        this.fetchData()
    },
}
</script>
